import http from 'plugins/axios';

export default {
  uploadPoster(data) {
    return http.post({
      url: '/la/admin/Poster/create',
      data,
      dataType: 'form'
    });
  },
  updatePoster(data) {
    return http.post({
      url: '/la/admin/Poster/update',
      data,
      dataType: 'form'
    });
  },
  getList(data) {
    return http.get({
      url: '/la/admin/Poster/getList',
      data
    });
  },
  removeList(id) {
    return http.post({
      url: `/la/admin/Poster/delete/${id}`
    });
  }
};
